import React from 'react'
import * as Styled from './Accessibility.styles'
import { Grid, Icon } from 'components/atoms'
import PropTypes from 'prop-types'
import { getAccessibilityIcon } from './helpers/constants'

/**
 * @returns {*}
 * @constructor
 */
const Accessibility = ({ items }) => {
  // all departments share the same data so only first element is taken
  const [selectedData] = items

  return (
    <Styled.AccessibilityComponent>
      <Grid container>
        <Grid item xs={ 12 } md={ 4 }></Grid>
        <Grid item xs={ 12 } md={ 8 }>
          {selectedData.categories &&
            selectedData.categories.map((category, index) => (
              <div key={ index }>
                {category.headline && (
                  <p className={ 'list-headline' }>
                    <b>{category.headline}</b>
                  </p>
                )}
                {category.items && (
                  <ul>
                    {category.items.map((item, i) => (
                      <li key={ i }>
                        <div className={ 'icons' }>
                          {item.icons.map((iconKey) => (
                            <Icon
                              className={ `list-icon` }
                              icon={ getAccessibilityIcon(iconKey) }
                              key={ iconKey }
                            />
                          ))}
                        </div>
                        <div className={ 'description' }>
                          <span>{item.description}</span>
                        </div>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
        </Grid>
      </Grid>
    </Styled.AccessibilityComponent>
  )
}

Accessibility.prototype = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      hospitalId: PropTypes.string,
      name: PropTypes.string,
      treatments: PropTypes.shape({
        cases: PropTypes.number,
      }),
      categories: PropTypes.arrayOf(
        PropTypes.shape({
          headline: PropTypes.string,
          items: PropTypes.arrayOf(
            PropTypes.shape({
              description: PropTypes.string.isRequired,
              icons: PropTypes.arrayOf(PropTypes.string).isRequired,
            })
          ),
        })
      ),
    })
  ),
}

export default Accessibility
